import { STATSIG_FEATURE_GATES } from './ppc-feature-gates';

export const PPC_ENABLE_MOCK_PROMO_AVAILABLE_API = 'mock-promo-available-api';

// Info: After fixing the types, ENABLE_ACCESS_PPC can be removed, otherwise server throws a type error.
// Type comes from: { FeatureFlagKeys } from '@atlassian/cssxp-utils-generic';
export const ENABLE_ACCESS_PPC = 'enable-access';

export const ENABLE_NEW_SOLD_TO_ADDRESS_SEARCH = 'enable-new-sold-to-addresses-table-in-global-search';

// STATSIG migrated feature flags
export const ENABLE_DESIGN_ITERATION_1 = STATSIG_FEATURE_GATES.ENABLE_DESIGN_ITERATION_1;
export const ENABLE_POST_OFFICE_NOTIFICATIONS = STATSIG_FEATURE_GATES.ENABLE_POST_OFFICE_NOTIFICATIONS;
export const ENABLE_ORG_BASED_SEARCH_FOR_SOLD_TO_ADDRESS =
  STATSIG_FEATURE_GATES.ENABLE_ORG_BASED_SEARCH_FOR_SOLD_TO_ADDRESS;
export const ENABLE_PREMIUM_ANNUAL_TRIAL_IN_PPC = STATSIG_FEATURE_GATES.ENABLE_PREMIUM_ANNUAL_TRIAL_IN_PPC;
